var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1068_19888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19373 3.7633C6.93169 2.43998 7.30038 1.77832 7.85196 1.77832C8.40354 1.77832 8.77223 2.43998 9.51019 3.7633L9.70123 4.10578C9.91091 4.48204 10.0158 4.67017 10.1788 4.79424C10.3419 4.9183 10.5458 4.96431 10.9535 5.05634L11.3239 5.14021C12.7568 5.46463 13.4726 5.62655 13.6432 6.17464C13.8133 6.72214 13.3252 7.29352 12.3485 8.4357L12.0957 8.731C11.8184 9.05542 11.6792 9.21793 11.6169 9.41829C11.5546 9.61923 11.5755 9.8359 11.6175 10.2687L11.6559 10.663C11.8033 12.1872 11.8773 12.9491 11.4311 13.2875C10.9849 13.6259 10.314 13.3172 8.97317 12.6998L8.62545 12.5402C8.24453 12.3643 8.05407 12.2769 7.85196 12.2769C7.64985 12.2769 7.45939 12.3643 7.07847 12.5402L6.73133 12.6998C5.38995 13.3172 4.71897 13.6259 4.2734 13.2881C3.82666 12.9491 3.90063 12.1872 4.04799 10.663L4.08643 10.2692C4.12837 9.8359 4.14934 9.61923 4.08643 9.41887C4.02469 9.21793 3.88549 9.05542 3.60824 8.73158L3.35546 8.4357C2.3787 7.2941 1.89061 6.72272 2.06068 6.17464C2.23075 5.62655 2.94775 5.46405 4.38057 5.14021L4.75101 5.05634C5.15814 4.96431 5.36141 4.9183 5.52508 4.79424C5.68875 4.67017 5.79301 4.48204 6.00269 4.10578L6.19373 3.7633Z",
    fill: "#EA7128",
    stroke: "#EA7128",
    strokeWidth: 0.873672
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1068_19888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9787,
    height: 13.9787,
    fill: "white",
    transform: "translate(0.863281 0.613281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar1);
export default __webpack_public_path__ + "static/media/rating-star-1.caad0822810cc179dad9f477ad666323.svg";
export { ForwardRef as ReactComponent };